import {
  AccEntryAddProvider,
  AccEntryCommentsProvider,
  AccEntryOperProvider,
  AccEntrySearchProvider,
  AccEntryService,
  AccEntryViewProvider,
  AccEntryXlsxProvider,
  HttpService,
} from '@lk/api'

export const makeAccEntryService = (http: HttpService, baseUrl: string) =>
  new AccEntryService(
    new AccEntrySearchProvider(http, baseUrl),
    new AccEntryViewProvider(http, baseUrl),
    new AccEntryAddProvider(http, baseUrl),
    new AccEntryOperProvider(http, baseUrl),
    new AccEntryCommentsProvider(http, baseUrl),
    new AccEntryXlsxProvider(http, baseUrl),
  )
